module.exports = __webpack_public_path__ + "static/img/pc-pic01.2bea0a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/study/pc-pic01.png
// module id = y22V
// module chunks = 0